"use client";

import { type PropsWithChildren } from "react";
import type React from "react";

import { useServerErrorRedirect } from "@/hooks/server-error-redirect.hook";

const ServerErrorWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  useServerErrorRedirect();

  return children;
};

export default ServerErrorWrapper;
